import { money, ruDate } from './userCardFormat';
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
/** Past its last day: nobody can take it, and a mailing with it won't start. */
export function giftExpired(gift, today = new Date()) {
    const [y = 0, m = 1, d = 1] = gift.expires_on.split('-').map(Number);
    return today > new Date(y, m - 1, d, 23, 59, 59, 999);
}
/** «500 ₽ · до 31.10.2026 · получили 12». */
export function giftSummary(gift, today = new Date()) {
    return [
        money(gift.amount, '₽'),
        `${giftExpired(gift, today) ? 'истёк' : 'до'} ${ruDate(gift.expires_on)}`,
        `получили ${gift.claims_count}`,
    ].join(' · ');
}
export const giftDraft = (gift) => ({
    name: gift?.name ?? '',
    amount: gift ? String(gift.amount) : '',
    expiresOn: gift?.expires_on ?? '',
});
/** The POST body for a new gift, or the PATCH of what changed; and what is wrong. */
export function giftForm(gift, d) {
    const errors = {};
    const name = d.name.trim();
    if (!name)
        errors.name = 'Нужно название';
    else if (/[\r\n]/.test(name))
        errors.name = 'Одной строкой';
    else if (name.length > 128)
        errors.name = 'Не длиннее 128 знаков';
    if (!(/^\d+$/.test(d.amount.trim()) && Number(d.amount) > 0)) {
        errors.amount = 'Целое число рублей больше 0';
    }
    if (!DATE_RE.test(d.expiresOn))
        errors.expiresOn = 'Нужна дата';
    const next = { name, amount: Number(d.amount), expires_on: d.expiresOn };
    if (!gift)
        return { body: next, errors };
    const patch = {};
    if (next.name !== gift.name)
        patch.name = next.name;
    if (next.amount !== gift.amount)
        patch.amount = next.amount;
    if (next.expires_on !== gift.expires_on)
        patch.expires_on = next.expires_on;
    return { body: patch, errors };
}
